import { render, staticRenderFns } from "./UserPicture.vue?vue&type=template&id=1684b2a6&"
import script from "./UserPicture.vue?vue&type=script&lang=js&"
export * from "./UserPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports